<template>
    <div class="table__wrap">
        <div class="table__nav">
            <el-tabs v-model="activeName">
                <el-tab-pane name="first">
                  <span slot="label" v-if="bannerData.zhiwei_number===new_zhiwei">职位({{bannerData.zhiwei_number}})</span>
                  <span slot="label" v-else>职位({{new_zhiwei}})</span>
                  <Hire v-on:allData="allData"></Hire>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <span slot="label" v-if="bannerData.jianli_number===new_jianli">简历({{bannerData.jianli_number}})</span>
                  <span slot="label" v-else>简历({{new_jianli}})</span>
                  <JianLi></JianLi>
                </el-tab-pane>
                <el-tab-pane name="third">
                  <span slot="label" v-if="bannerData.jianli_yaoyue_number===new_yaoyue">邀约({{bannerData.jianli_yaoyue_number}})</span>
                  <span slot="label" v-else>邀约({{new_yaoyue}})</span>
                  <YaoYue></YaoYue>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                  <span slot="label" v-if="bannerData.jianli_shuangyue_number===new_shuangyue">爽约({{bannerData.jianli_shuangyue_number}})</span>
                  <span slot="label" v-else>爽约({{new_shuangyue}})</span>
                  <ShuangYue></ShuangYue>
                </el-tab-pane>
                <el-tab-pane name="fifth">
                  <span slot="label" v-if="bannerData.jianli_mianshi_number===new_mianshi">已面试({{bannerData.jianli_mianshi_number}})</span>
                  <span slot="label" v-else>已面试({{new_mianshi}})</span>
                  <MianShi></MianShi>
                </el-tab-pane>
                <el-tab-pane name="sixth">
                  <span slot="label" v-if="bannerData.jianli_ruzhi_number===new_ruzhi">入职({{bannerData.jianli_ruzhi_number}})</span>
                  <span slot="label" v-else>入职({{new_ruzhi}})</span>
                  <RuZhi></RuZhi>
                </el-tab-pane>
                <el-tab-pane name="seventh">
                  <span slot="label" v-if="bannerData.ziyuan_number===new_ziyuan">储备库({{bannerData.ziyuan_number}})</span>
                  <span slot="label" v-else>储备库({{new_ziyuan}})</span>
                  <ChuBei></ChuBei>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import Hire from '../components/Hire.vue'
import JianLi from '../components/JianLi.vue'
import YaoYue from '../components/YaoYue.vue'
import ShuangYue from '../components/ShuangYue.vue'
import MianShi from '../components/MianShi.vue'
import RuZhi from '../components/RuZhi.vue'
import ChuBei from '../components/ChuBei.vue'

export default {
  data () {
    return {
      activeName: 'first',
      bannerData: {},
      new_zhiwei: '',
      new_jianli: '',
      new_yaoyue: '',
      new_shuangyue: '',
      new_mianshi: '',
      new_ruzhi: '',
      new_ziyuan: ''
    }
  },
  components: {
    Hire,
    JianLi,
    YaoYue,
    ShuangYue,
    MianShi,
    RuZhi,
    ChuBei
  },
  created () {
    this.getBannerData()
  },
  methods: {
    allData (val) {
      let self = this
      self.new_zhiwei = val.zhiwei_number
      self.new_jianli = val.jianli_number
      self.new_yaoyue = val.jianli_yaoyue_number
      self.new_shuangyue = val.jianli_shuangyue_number
      self.new_mianshi = val.jianli_mianshi_number
      self.new_ruzhi = val.jianli_ruzhi_number
      self.new_ziyuan = val.ziyuan_number
    },
    getBannerData () {
      var self = this
      this.$axios
        .get('/api/zhaopin2', {
          params: {}
        })
        .then(function (res) {
          self.bannerData = res.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
// 以下都是职位样式
.title {
  font-size: 12px;
  color: #999999;
}

.table {
  &__wrap {
    margin-top: 20px;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 1);
  }
  &__nav {
    font-size: 16px;
    margin-bottom: 0; // padding-bottom: 1px;
    box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
    a#{&}--active {
      color: rgba(255, 96, 2, 1);
      box-shadow: 0px 2px 0px 0px rgba(255, 96, 2, 1);
    }
    a {
      display: inline-block;
      text-decoration: none;
      line-height: 21px;
      font-size: 16px;
      text-align: center;
      padding: 10px 20px;
      text-align: center;
      color: #333333;
      span {
        color: rgba(0, 0, 0, 0.65);
        font-size: 12px;
        text-align: left;
        border-radius: 40px;
        border: 1px #d9d9d9 solid;
        padding: 0px 5px;
        margin-left: 5px;
        font-family: HelveticaNeue;
      }
    }
  }
  &__list {
    margin: 0px 20px 0 20px;
    border: 1px solid #e9e9e9;
  }
}

.table__search {
  font-size: 14px;
  color: #333333;
  padding: 20px;
}

.btn-add {
  // display:inline-block;
  color: #ffffff;
  font-size: 12px;
  width: 80px;
  height: 32px;
  border-radius: 3px;
  background-color: rgba(255, 96, 2, 1);
  padding: 10px 16px;
}

.pagination {
  float: right;
  padding: 10px;
}

.hide {
  visibility: hidden;
}

.search {
  cursor: pointer;
  color: #1989fa;
}

.el-select {
  width: 150px;
}

.el-select:not(:first-child) {
  margin-left: 10px;
}
</style>
